module.exports = __webpack_public_path__ + "img/send_icon.8d4deb0d.svg";